/**
 * support.js
 *
 * Single source of truth for the club's human contact handles.
 *
 * These were previously a bare `'https://t.me/poolit_support'` literal copy-pasted
 * into MembershipStandingCard.vue and OrdersPage.vue. That handle went dead without
 * anyone noticing, so every member who tapped «تواصل مع الدعم» from a blocked or
 * rejected state reached nothing. One module, one place to fix.
 *
 * Routing rule (owner-locked 2026-07-16) — route by the member's QUESTION, not by
 * the handle's name:
 *
 *   SELLERS_CLUB_ADMIN  → the default human. Registration, activation, the first
 *                         deposit, and ANY question or clarification.
 *   APP_ADMIN           → technical problems ONLY (app broken, errors, nothing loads).
 *
 * NAMING TRAP: `@SellersClubSupport` is the *Poolit app / tech* admin despite the
 * name reading like the Sellers Club's support desk. Business and money questions
 * go to SELLERS_CLUB_ADMIN. Do not wire these by intuition.
 */

export const SUPPORT_HANDLES = Object.freeze({
  /** Sellers Club admin — the default human for anything a member is unsure about. */
  SELLERS_CLUB_ADMIN: 'sakr_eslam',
  /** Poolit app admin — technical problems only. */
  APP_ADMIN: 'SellersClubSupport',
});

/**
 * Build the canonical t.me URL for a handle.
 *
 * The full `https://t.me/<handle>` form is required: the Telegram SDK's
 * `openTelegramLink` validates against /^https:\/\/t.me\/.+/ and throws on anything
 * else, so shorthand (`@name`, `t.me/name`) is not acceptable here.
 *
 * @param {string} handle Bare username, no leading '@'.
 * @returns {string}
 */
export function telegramUrl(handle) {
  return `https://t.me/${handle}`;
}
